<div class="flex flex-row justify-center items-center">
  {{ label }}<mat-icon>{{ value === 'True' ? 'check' : 'close' }}</mat-icon>
</div>
